// @flow
import { createAction } from 'redux-actions';
import type { ClientUserProfileRecord } from './types';

const createFetchAction = (resourceType: string) =>
  createAction(`@client/${resourceType}/fetch`, (clientId: Id) => clientId);

const createStoreAction = (resourceType: string) =>
  createAction(
    `@client/${resourceType}/store`,
    (payload: Array<ClientUserProfileRecord>) => payload,
    (_, clientId: Id) => clientId
  );

// profiles
export const fetchClientUserProfiles = createFetchAction('profiles');
export const storeClientUserProfiles = createStoreAction('profiles');

// export user profiles
export const fetchClientExpertUserProfiles = createFetchAction(
  'expertProfiles'
);
export const storeClientExportUserProfiles = createStoreAction(
  'expertProfiles'
);



// WEBPACK FOOTER //
// ./src/containers/client/userProfileActions.js